export default {
  gnb: {
    oneToOne: "1:1 Inquiry",
    myInquiry: "My Inquiry History",
    faq: "FAQ",
    notice: "Notice",
  },
  table: {
    filter: "Filter",
    searchText: "Search Text",
    enterSearchKeyword: "Enter search keyword",
    sort: "Sort",
    ascending: "Ascending",
    descending: "Descending",
    noSort: "No Sort",
    clear: "Clear",
    apply: "Apply",
    filterBy: "Filter By",
    all: "All",
    noData: "No Data",
  },
  pagination: {
    pageSize: "Page Size:",
    page: "Page",
    firstPage: "First Page",
    previousPage: "Previous Page",
    nextPage: "Next Page",
    lastPage: "Last Page",
    showing: "Showing",
    total: "Total",
    entries: "entries",
  },
  login: {
    links: {
      noAccount: "Don't have an account?",
    },
    error: {
      noId: "Please enter your ID.",
      noPassword: "Please enter your Password.",
      changePassword: "Please change your password.",
      periodPassed: "The password change period (90 days) has passed. Please change your password.",
      loginFailed: "Login failed more than 5 times.<BR/> Please contact the administrator",
      noUser: "No matching user found.",
    },
    changePassword: {
      notification: "Including uppercase, lowercase, and special characters, enter 8 to 16",
      prePassword: "Existing Password",
      password: "Password",
      confirm: "Confirm",
      change: "Change",
      cancel: "Cancel",
      error: {
        different: "The passwords are different.",
        overNumber: "The password must be at least 8 characters long.",
        underNumber: "The password must be 16 characters or less.",
        atleastNumber: "Password should contain at least one number.",
        capital: "Password should contain at least one capital letter.",
        small: "Password should contain at least one uppercase letter.",
        special: "Password should contain at least one special character.",
        general: "An error occurred while changing password. Please try again.",
      },
    },
  },
  signup: {
    title: "Sign Up",
    labels: {
      userId: "User ID",
      password: "Password",
      confirmPassword: "Confirm Password",
      language: "Language",
      role: "Role",
      site: "Site",
    },
    placeholders: {
      selectLanguage: "Select a language",
      selectRole: "Select a role",
      selectSite: "Select a site",
    },
    links: {
      haveAccount: "Already have an account?",
    },
    validation: {
      password: {
        required: "Please enter a password.",
        minLength: "Password must be at least 8 characters long.",
        maxLength: "Password must be 16 characters or less.",
        requireNumber: "Password must contain at least one number.",
        requireUppercase: "Password must contain at least one uppercase letter.",
        requireLowercase: "Password must contain at least one lowercase letter.",
        requireSpecialChar: "Password must contain at least one special character.",
      },
      confirmPassword: {
        required: "Please confirm your password.",
        mismatch: "Passwords do not match.",
      },
    },
    messages: {
      signupSuccess: "Sign up completed successfully. Please log in.",
      signupError: "Sign up failed.",
      signupErrorGeneral: "An error occurred during sign up.",
      allFieldsRequired: "Please fill in all fields correctly.",
    },
  },
  selectSite: {
    title: "Select Site",
    subtitle: "Please select a site to use",
    notice: "⚠️ You must select a site to access other menus",
    loading: "Loading site list...",
    error: "Failed to load site list.",
    selectError: "An error occurred while selecting site.",
  },
  home: {
    title: "Dashboard",
    summary: "Summary",
    description: "Monitor the overall status of the robot system.",
    robotStatus: {
      title: "Robot Status",
      activeRobots: "Active Robots",
      waitingRobots: "Waiting Robots",
      run: "RUN",
      idle: "Idle",
      error: "Error",
      charging: "Charging",
    },
    serviceStatus: {
      title: "Service Status",
      running: "Running",
      waiting: "Waiting",
    },
    jobStatus: "Job Status",
    todayJob: "Today's Job",
    avgJobTime: "Average Job Time",
    failJob: "Fail Job",
    job: "Job",
    sec: "Sec",
    alarmLogTitle: "Alarm / Error Log",
    priority: "Priority",
    status: "Status",
    totalDropDown: "Total",
    alarmColumns: {
      priority: "Priority",
      eqipmentName: "Equipment Name",
      desc: "Description",
      occurTime: "Occur Time",
      releaseTime: "Release Time",
      position: "Position",
    },
    error: {
      siteIdRequired: "Site ID is required",
      robotTypeCodeRequired: "Robot type code is required",
      fetchRobotSummaryByStatus: "Error fetching robot summary by status",
      fetchRobotSummaryByType: "Error fetching robot summary by type",
      fetchRobotJobs: "Error fetching robot jobs",
      fetchRobotImage: "Error fetching robot image",
      fetchAlarmLogs: "Error fetching alarm logs",
      fetchAlarmStatusCode: "Error fetching alarm status codes",
      fetchActiveAlarmCount: "Error fetching active alarm count",
      downloadAlarmReport: "Error downloading alarm report",
      invalidBlob: "Invalid file format received",
    },
  },
  logout: {
    confirm: "Are you sure you want to logout?",
    description: "Your current work may not be saved if you logout.",
    success: "You have been logged out.",
    error: "An error occurred during logout.",
  },
  kiosk: {
    mainTitle: "WELCOME TO<br />Singlex AutoStore",
  },
  messages: {
    removeNotAllowed: "Remove not allowed",
    overlayNoRowsTemplate: "There is no data to display.",
    loading: "Loading...",
    moveBin: "BIN is coming.",
    deleteConfirm: "Are you sure you want to delete it?",
    bulkDeleteConfirm: "Are you sure you want to delete {number} selected items?",
    saveConfirm: "Do you want to save?",
    duplication: "Duplicate value found.",
    changeConfirm: "Are you sure you want to cancel the editing and changes?",
    save: "It is saved.",
    cancel: "It is canceled.",
    delete: "It is deleted.",
    notSelected: "No data to process.",
    resend: " have been resent",
    release: " have been released",
    sendConfirm: "Do you want to send?",
    sendComplete: "I sent it.",
    sendCancelConfirm: "Do you want to cancel the send?",
    sendCancelComplete: "The send has been canceled.",
    sendStockAdjustment: "Would you like to make stock adjustments?",
    sendStockTaking: "Do you want to send stocktaking?",
    sendStockTakingCancel: "Do you want to cancel stocktaking?",
    createSuccess: "Created successfully.",
    createFailed: "Failed to create.",
    createError: "An error occurred while creating.",
    editSuccess: "Updated successfully.",
    editFailed: "Failed to update.",
    editError: "An error occurred while updating.",
    deleteSuccess: "Deleted successfully.",
    deleteFailed: "Failed to delete.",
    noSelectedItems: "No items selected.",
    bulkDeleteSuccess: "{number} Selected items have been deleted successfully.",
    bulkDeleteFailed: "Failed to bulk delete.",
    exportSuccess: "Export completed successfully.",
    exportFailed: "Failed to export.",
    confirmDelete: "Are you sure you want to delete the selected item?",
    // Common validation messages
    validation: {
      required: "This field is required.",
      invalidFormat: "Invalid format.",
      minLength: "Please enter at least {min} characters.",
      maxLength: "Maximum {max} characters allowed.",
      email: "Invalid email format.",
      phone: "Invalid phone number format.",
      number: "Only numbers are allowed.",
      positiveNumber: "Only positive numbers are allowed.",
      date: "Invalid date format.",
      time: "Invalid time format.",
      lengthExceeded: "Input exceeds maximum length of {max} characters.",
      lengthTooShort: "Minimum length is {min} characters.",
    },

    // Common error messages
    errors: {
      network: "Network error occurred.",
      server: "Server error occurred.",
      system: "System error occurred. Please refresh the page.",
      unauthorized: "Unauthorized access.",
      forbidden: "Access forbidden.",
      notFound: "Requested resource not found.",
      timeout: "Request timeout.",
      unknown: "Unknown error occurred.",
      validation: "Invalid input data.",
      duplicate: "Duplicate data found.",
      notExist: "Data does not exist.",
      loadDataError: "Failed to load data.",
    },

    // Common success messages
    success: {
      save: "Saved successfully.",
      update: "Updated successfully.",
      delete: "Deleted successfully.",
      create: "Created successfully.",
      send: "Sent successfully.",
      complete: "Completed successfully.",
      success: "Success.",
    },

    // Pagination related messages
    pagination: {
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
    },
    // Search related messages
    search: {
      searchBy: " search",
      search: "Search",
    },

    // Date related messages
    date: {
      selectDateRange: "Select a date range",
    },
    // API related messages
    apiSuccess: "Processing completed successfully.",
    apiError: "An error occurred.",
    apiNetworkError: "A network error occurred.",
    apiTimeout: "Request timeout.",
    apiUnauthorized: "Unauthorized access.",
    apiSessionTimeout: "Session has timed out. Please log in again.",
    apiNotFound: "Requested resource not found.",
    apiServerError: "Server error occurred.",
    apiValidationError: "Input data is invalid.",
    networkError: "Please check your network connection.",
    // Question popup messages
    editConfirm: "Do you want to edit?",
    updateConfirm: "Do you want to update?",
    createConfirm: "Do you want to create?",
    importConfirm: "Do you want to import data?",
    exportConfirm: "Do you want to export the data?",
    resetConfirm: "Do you want to reset?",
    refreshConfirm: "Do you want to refresh?",
    closeConfirm: "Do you want to close?",
    cancelConfirm: "Do you want to cancel?",
    proceedConfirm: "Do you want to continue?",
    stopConfirm: "Do you want to stop?",
    retryConfirm: "Do you want to retry?",
  },
  // Tooltip messages
  tooltip: {
    clearAll: "Clear all selected items",
    clearSearch: "Clear search",
  },
  labels: {
    sir: "",
    selectTenant: "Choose a tenant",
    selectCenter: "Choose a center",
    list: "List",
    portListInform: "(Manage Ports at each Center)",
    menu: "Menu",
    favMenu: "Favorites",
    // Multiselect
    pressEnter: 'Press Enter to add "{query}"',
    noResults: "No results found",
    startTyping: "Start typing to search...",
  },

  buttons: {
    add: "+",
    remove: "-",
    defaultConfirm: "Confirm",
    defaultCancel: "Cancel",
    save: "Save",
    search: "Search",
    send: "Send",
    sendCancel: "Send Cancel",
    downloadExcel: "Download Excel",
    uploadExcel: "Import Excel",
    login: "Log in",
    loggingIn: "Logging In...",
    logout: "Log out ",
    signup: "Sign Up",
    signingUp: "Signing Up...",
    main: "Main",
    refresh: "Refresh",
    delete: "DEL",
    detail: "Detail",
    callBin: "Call BIN",
    releaseBin: "Return BIN",
    release: "Release",
    resend: "Resend",
    deleteRow: "Delete",
    expandAll: "Expand All",
    collapseAll: "Collapse All",
    yes: "Yes",
    no: "No",
    deleteSelected: "Delete Selected",
    defaultClose: "Close",
    downloadExcelAsync: "Download excel (A)",
    // 추가 버튼 메시지
    cancel: "Cancel",
    update: "Update",
    changing: "Changing...",
    create: "Create",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    reset: "Reset",
    export: "Export",
    import: "Import",
    select: "Select",
    deselect: "Deselect",
    newAdd: "New Add",
    bulkDelete: "Bulk Delete",
    clearAll: "Clear All",
  },
  errors: {
    expiredCertification: "Your certification has expired. Please log in again.",
    occurred: "An error occurred during processing.",
    unavailableAutostore: "You are not an Autostore user.",
    empty: " is not entered.",
    invalidUrl: " is not valid Url.",
    autostoreWarning: "Start working or return to the main screen.<br /> Automatically shuts down if not working.",
    autostoreQuit: "It shuts down automatically because it has not been used for a long time.",
    autostoreEtcDetail: "Please enter no more than 500 characters for details",
    number: " is allowed to enter numbers only",
    resendFail: "re-send(s) failed",
    releaseFail: "release(s) fialed",
    date: " Enter 8 digits in YYYYMMDD format",
    dateRange: "The start date must be less than the end date.",
    excelImport: "Excel file does not fit the form",
    exceedNumberInnerTab: "You cannot open more than 15 tabs.",
  },
  comboBox: {
    useOrNot: {
      use: "Use",
      not: "Unused",
    },
    cmptYn: {
      cmpt: "Completion",
      not: "Incompletion",
    },
    abnormalYn: {
      abnormal: "Abnormal",
      normal: "Normal",
    },
    successYn: {
      success: "Success",
      notYet: "Not sent",
      error: "Error",
    },
  },
  popups: {
    excel: {
      cancelButton: "No",
      warning: "Check the screen before downloading Excel.",
      confirm: "Would you like to download Excel?",
    },
  },
  menus: {
    userManagement: "User Management",
    siteManagement: "Site Management",
    zoneManagement: "Zone Management",
    codeManagement: "Code Management",
    robotGroupManagement: "Robot Group Management",
    robotManagement: "Robot Management",
    mapManagement: "Map Management",
    menuManagement: "Menu Management",
    commonManagement: "Common Management",
    accountManagement: "Account Management",
    systemManagement: "System Management",
    reportManagement: "Report Management",
    monitoring: "Monitoring",
    settings: "Settings",
    cafe: "Cafe",
    telephone: "Telephone",
    cafeOrderManagement: "Cafe Order Management",
    householdManagement: "Household Management",
    cafeCalendar: "Cafe Calendar",
    help: "Help",
    // 추가 메뉴 번역들
    home: "Home",
    dashboard: "Dashboard",
    robotControl: "Robot Control",
    report: "Report",
    common: "Common",
    serviceManagement: "Service Management",
    // DB에서 오는 실제 메뉴 이름들 (공백 포함)
    Monitoring: "Monitoring",
    "Robot Control": "Robot Control",
    Report: "Report",
    Home: "Home",
    Common: "Common",
    Service: "Service",
    alarmRoleMapping: "Alarm Role Mapping",
    "Monthly Report": "Monthly Report",
    "Site Info": "Site Info",
    "Robot Group Info": "Robot Group Info",
    "Robot Info": "Robot Info",
    "Zone Info": "Zone Info",
    "Common Code Info": "Common Code Info",
    "User Info": "User Info",
    "Map Info": "Map Info",
    "Station Info": "Station Info",

    // 추가 메뉴들
    "Menu Management": "Menu Management",
    "System Management": "System Management",
    "Account Management": "Account Management",
    Settings: "Settings",
    Help: "Help",
    Dashboard: "Dashboard",
    // 서비스 관련 메뉴들
    "Service Info": "Service Info",
    "Service Execution": "Service Execution",
    "Patrol Robot": "Patrol Robot",
    "Cleaning Robot": "Cleaning Robot",
    "Barista Robot": "Barista Robot",
    "Carry Robot": "Carry Robot",
    "Service Report": "Service Report",
    "Service Order Report": "Service Order Report",
    "Robot Alarm Log": "Robot Alarm Log",
    // 더 많은 메뉴가 필요하면 여기에 추가
    serviceSetup: "Service Setup",
    "Alarm Role Mapping": "Alarm Role Mapping",
  },
  // User management related messages (EN)
  user: {
    management: {
      title: "User Management",
      actions: {
        addUser: "Add User",
        editUser: "Edit User",
        deleteUser: "Delete User",
        deleteSelected: "Delete Selected",
        bulkDelete: "Bulk Delete",
        export: "Export",
        actions: "Actions",
      },
      search: {
        userId: "User ID",
        userName: "User Name",
        userStatusCode: "Status",
      },
      columns: {
        userId: "User ID",
        userName: "User Name",
        roleId: "Role",
        userStatusCode: "Status",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
        userLanguageCode: "Language",
      },
      roles: {
        admin: "Administrator",
        user: "User",
        viewer: "Viewer",
        manager: "Manager",
        unspecified: "Unspecified",
      },
      messages: {
        noSearchResults: "No search results found.",
        loading: "Loading...",
        addSuccess: "User has been added successfully.",
        addFailed: "Failed to add.",
        deleteConfirm: "Are you sure you want to delete this user?",
        deleteSuccess: "User has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        editSuccess: "User information has been updated successfully.",
        editFailed: "Failed to update.",
      },
      addModal: {
        title: "Add User",
      },
      editModal: {
        title: "Edit User",
        userNamePlaceholder: "Enter user name",
      },
    },
  },
  // Site related messages (EN)
  site: {
    management: {
      title: "Site Management",
      actions: {
        addSite: "Add Site",
        editSite: "Edit Site",
        deleteSite: "Delete Site",
        deleteSelected: "Delete Selected",
        bulkDelete: "Bulk Delete",
        export: "Export",
        actions: "Actions",
      },
      search: {
        siteId: "Site ID",
        siteName: "Site Name",
        useYn: "Use Status",
      },
      columns: {
        siteId: "Site ID",
        siteName: "Site Name",
        siteDescription: "Site Description",
        useYn: "Use Status",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
      },
      messages: {
        noSearchResults: "No search results found.",
        loading: "Loading...",
        addSuccess: "Site has been added successfully.",
        addFailed: "Failed to add.",
        deleteConfirm: "Are you sure you want to delete this site??",
        deleteSuccess: "Site has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        editSuccess: "Site information has been updated successfully.",
        editFailed: "Failed to update.",
      },
      addModal: {
        title: "Add Site",
      },
      editModal: {
        title: "Edit Site",
        siteIdPlaceHolder: "Enter Site ID",
        siteNamePlaceHolder: "Enter site name",
        siteDescriptionPlaceHolder: "Enter site description",
      },
      modalTitles: {
        add: "Add Site",
        edit: "Edit Site",
      },
      options: {
        useYn: {
          Y: "Use",
          N: "Not Use",
        },
      },
    },
    change: {
      title: "Site Change",
      confirm: "Do you want to change the current site?",
      description: "You will be redirected to the site selection screen.",
      change: "Change",
      cancel: "Cancel",
    },
    selection: {
      title: "Site Selection",
      description: "Please select a site to use.",
    },
  },
  // Zone related messages (EN)
  zone: {
    management: {
      title: "Zone Management",
      actions: {
        addZone: "Add Zone",
        editZone: "Edit Zone",
        deleteZone: "Delete Zone",
        deleteSelected: "Delete Selected",
        bulkDelete: "Bulk Delete",
        export: "Export",
        actions: "Actions",
      },
      search: {
        zoneId: "Zone ID",
        siteId: "Site ID",
        zoneTypeCd: "Zone Type",
        zoneNm: "Zone Name",
        flrNo: "Floor Number",
        useYn: "Use Status",
      },
      columns: {
        zoneId: "Zone ID",
        siteId: "Site ID",
        zoneTypeCd: "Zone Type",
        zoneNm: "Zone Name",
        flrNo: "Floor Number",
        useYn: "Use Status",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
      },
      messages: {
        loading: "Loading...",
        deleteConfirm: "Are you sure you want to delete this zone?",
        deleteSuccess: "Zone has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        noSearchResults: "No search results found.",
        addSuccess: "Zone has been added successfully.",
        addFailed: "Failed to add.",
        editSuccess: "Zone information has been updated successfully.",
        editFailed: "Failed to update.",
      },
      addModal: {
        title: "Add Zone",
      },
      editModal: {
        title: "Edit Zone",
        siteIdPlaceholder: "Enter site ID",
        zoneNmPlaceholder: "Enter zone name",
        flrNoPlaceholder: "Enter floor number",
      },
      placeholders: {
        zoneId: "Enter zone ID",
        siteId: "Select site",
        zoneTypeCd: "Select zone type",
        zoneNm: "Enter zone name",
        flrNo: "Enter floor number",
        useYn: "Select use status",
      },
      options: {
        useYn: {
          Y: "Use",
          N: "Not Use",
        },
        zoneTypeCd: {
          storage: "Storage",
          work: "Work",
          picking: "Picking",
          staging: "Staging",
          cleaning: "Cleaning",
        },
      },
    },
  },
  // Monitoring related messages
  monitoring: {
    title: "Integrated Monitoring",
    integratedMonitoring: "Integrated Monitoring",
    total: "Total",
    utilization: "Utilization",
    totalRobots: "Total Robots",
    robotTotal: "Robot",
    statusTotal: "Status",
    searchForRobotName: "Search for Robot Name",
    lastUpdate: "Last Update",
    filterTotal: "Total", // Added for filter options
    columns: {
      robot: "Robot",
      status: "Status",
      position: "Position",
      battery: "Battery",
      details: "Details",
    },
    status: {
      run: "RUN",
      idle: "IDLE",
      error: "ERROR",
      charge: "CHARGE",
    },
    navigation: {
      home: "Home",
      monitoring: "Monitoring",
      robotControl: "Robot Control",
      report: "Report",
      comon: "Comon",
      service: "Service",
    },
    robotList: "Robot List",
    alarm: "Alarm",
    map: {
      battery: "Battery",
      details: "Details",
      fullScreen: "Full",
      reset: "Reset",
      showPath: "Show Path",
      hidePath: "Hide Path",
      tooltip: {
        robotName: "Name",
        type: "Type",
        status: "Status",
        battery: "Battery",
        location: "Location",
        floor: "Floor",
      },
    },
    robotDetail: {
      button: {
        detail: "Detail",
      },
      label: {
        destination: "DESTINATION",
        position: "POSITION",
        connection: "Connection",
        battery: "Battery",
        jobCount: "Job Count",
        jobProgress: "Job Progress",
        coverage: "Coverage",
        streaming: "Streaming",
      },
      streaming: {
        clickToStart: "Click to start streaming",
        retry: "Retry",
        screenshot: "Screen shot",
        viewInLargeWindow: "View in a large window",
      },
    },
  },
  // 공통 액션 (모든 화면에서 사용) - 영어
  common: {
    notAvailable: "N/A",
    actions: {
      back: "Back",
      home: "Home",
      refresh: "Refresh",
      settings: "Settings",
      help: "Help",
    },
    station: {
      title: "Station Management",
      lastUpdate: "Latest Update",
      stationSync: "Station Sync",
      stationList: "Station List",
      deRegistration: "De-Registration",
      robotGroup: "Robot Group",
      stationType: "Station Type",
      stationName: "Station Name",
      position: "Position",
      regisTime: "Registration Time",
      countOfService: "Count of Service",
      useYn: "Use Status",
      actions: "Actions",
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      unregisStation: "Unregistered Station",
      unregisStationTitle: "Unregistered Station",
      subTitle:
        "You can check the Stations recognized by the robot that have not yet been registered on the control platform.",
      regisStation: "Registration Station",
      subTitle2:
        "Please select a Station from the list on the left and register a name and type to be used on the platform.",
      subTitle3: "Please select a Station to register.",
      subTitle4: 'Are you sure you want to register station "{stationName}"?',
      subTitle5: "Input Error",
      subTitle6: "Station has been registered successfully.",
      subTitle7: "Failed to register station. Please try again.",
      regisFail: "Registration Failed",
      regisSuccess: "Station has been registered successfully.",
      stationGroup: "Station Group",
      stationGroupName: "Station Group Name",
      creatStationGroupSuccess: "Station group has been added successfully.",
      creatStationGroupFailed: "Failed to add.",
      register: "Register",
      createStationGroup: "Add Station Group",
      confirmRegister: "Confirm Registration",
      confirmDeregistration: 'Are you sure you want to deregister station "{stationName}"?',
      deregisterSuccess: "Station has been deregistered successfully.",
      deregisterError: "Failed to deregister station.",
      success: "Success",
      ok: "OK",
      total: "Total",
      syncSuccess: "Station synchronization completed successfully.",
      syncError: "Failed to synchronize stations. Please try again.",
      updateSuccess: "Station information has been updated successfully.",
      updateError: "Failed to update.",
      deleteConfirm: "Are you sure you want to delete this station?",
      deleteSuccess: "Station has been deleted successfully.",
      deleteError: "Failed to delete.",
      editStation: "Edit Station",
      latitude: "Latitude",
      longitude: "Longitude",

      errors: {
        stationGroupRequired: "Please select a Station Group.",
        stationTypeRequired: "Please select a Station Type.",
        stationNameRequired: "Please enter Station Name.",
        stationNameExist: "Station Name already exists.",
      },
      input: {
        stationGroupId: "Enter Station Group ID",
        stationGroupName: "Enter Station Group Name",
      },
      placeholders: {
        latitude: "Enter latitude (-90 to 90)",
        longitude: "Enter longitude (-180 to 180)",
        useYn: "Select Use Status",
      },
      options: {
        useYn: {
          Y: "Use",
          N: "Not Use",
        },
      },
    },
    options: {
      useYn: {
        all: "All",
        yes: "Use",
        no: "Not Use",
      },
      all: "All",
    },
  },
  // Code related messages (EN)
  code: {
    management: {
      title: "Code Management",
      actions: {
        addCode: "Add Code",
        editCode: "Edit Code",
        deleteCode: "Delete Code",
        deleteSelected: "Delete Selected",
        bulkDelete: "Bulk Delete",
        export: "Export",
        actions: "Actions",
      },
      search: {
        commonCodeGroup: "Code Group",
        commonCode: "Common Code",
        codeName: "Code Name",
        useYn: "Use Status",
      },
      columns: {
        commonCodeGroup: "Code Group",
        commonCode: "Common Code",
        codeName: "Code Name",
        codeDescription: "Code Description",
        useYn: "Use Status",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
      },
      messages: {
        noSearchResults: "No search results found.",
        loading: "Loading...",
        addSuccess: "Code has been added successfully.",
        addFailed: "Failed to add.",
        deleteConfirm: "Are you sure you want to delete this code?",
        deleteSuccess: "Code has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        editConfirm: "Do you want to edit the code?",
        editSuccess: "Code information has been updated successfully.",
        editFailed: "Failed to update.",
      },
      editModal: {
        title: "Edit Code",
        codeNamePlaceholder: "Enter code name",
        codeDescriptionPlaceholder: "Enter code description",
        commonCodeGroupPlaceholder: "Enter common code group",
        commonCodePlaceholder: "Enter common code",
      },
      options: {
        useYn: {
          Y: "Use",
          N: "Not Use",
        },
      },
    },
  },
  // Robot Group related messages
  robotGroup: {
    management: {
      title: "Robot Group Management",
      actions: {
        addRobotGroup: "Add Robot Group",
        editRobotGroup: "Edit Robot Group",
        deleteRobotGroup: "Delete Robot Group",
        exportRobotGroup: "Export Robot Group",
        actions: "Actions",
      },
      search: {
        robotGrpId: "Robot Group ID",
        siteId: "Site ID",
        robotGrpName: "Robot Group Name",
        robotGrpTypeCd: "Robot Group Type",
        adapterId: "Adapter ID",
      },
      columns: {
        robotGrpId: "Robot Group ID",
        siteId: "Site ID",
        robotGrpName: "Robot Group Name",
        robotGrpTypeCd: "Robot Group Type",
        adapterId: "Adapter ID",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
      },
      messages: {
        noSearchResults: "No search results found.",
        loading: "Loading...",
        addSuccess: "Robot Group has been added successfully.",
        addFailed: "Failed to add.",
        deleteConfirm: "Are you sure you want to delete this robot group?",
        editSuccess: "Robot Group information has been updated successfully.",
        editFailed: "Failed to update.",
        deleteSuccess: "Robot Group has been deleted successfully.",
        deleteFailed: "Failed to delete.",
      },
      editModal: {
        title: "Edit Robot Group",
        robotGrpIdPlaceholder: "Enter robot group ID",
        robotGrpNamePlaceholder: "Enter robot group name",
        robotGrpTypeCdPlaceholder: "Enter robot group type",
        adapterIdPlaceholder: "Enter adapter ID",
      },
    },
  },
  robot: {
    management: {
      title: "Robot Management",
      actions: {
        addRobot: "Add Robot",
        editRobot: "Edit Robot",
        deleteRobot: "Delete Robot",
        exportRobot: "Export Robot",
        actions: "Actions",
      },
      search: {
        robotId: "Robot ID",
        robotGrpId: "Robot Group ID",
        robotName: "Robot Name",
        robotTypeCd: "Robot Type",
        siteId: "Site ID",
        useYn: "Use Status",
        robotModelId: "Robot Model ID",
        robotFmwVer: "Firmware Version",
        adpterId: "Adapter ID",
      },
      columns: {
        robotId: "Robot ID",
        robotGrpId: "Robot Group ID",
        robotName: "Robot Name",
        robotTypeCd: "Robot Type",
        siteId: "Site ID",
        useYn: "Use Status",
        robotModelId: "Robot Model ID",
        robotFmwVer: "Firmware Version",
        adpterId: "Adapter ID",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
      },
      messages: {
        noSearchResults: "No search results found.",
        loading: "Loading...",
        editConfirm: "Do you want to edit the robot?",
        deleteConfirm: "Are you sure you want to delete this robot?",
        addSuccess: "Robot has been added successfully.",
        addFailed: "Failed to add.",
        deleteSuccess: "Robot has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        editSuccess: "Robot information has been updated successfully.",
        editFailed: "Failed to update.",
      },
      editModal: {
        title: "Edit Robot",
        robotNamePlaceholder: "Enter robot name",
        robotTypeCdPlaceholder: "Enter robot type",
        robotModelIdPlaceholder: "Enter robot model ID",
        robotFmwVerPlaceholder: "Enter firmware version",
        adpterIdPlaceholder: "Enter adapter ID",
      },
      options: {
        useYn: {
          Y: "Use",
          N: "Not Use",
        },
      },
      placeholders: {
        robotId: "Enter robot ID",
        robotGrpId: "Enter robot group ID",
        robotName: "Enter robot name",
        robotTypeCd: "Enter robot type",
        siteId: "Select site",
        useYn: "Select use status",
        robotModelId: "Enter robot model ID",
        robotFmwVer: "Enter firmware version",
        adpterId: "Enter adapter ID",
      },
    },
  },
  // Map management
  map: {
    management: {
      title: "Map Management",
      actions: {
        actions: "Actions",
      },
      search: {
        mapId: "Map ID",
        siteId: "Site ID",
        mapName: "Map Name",
        mapTypeCd: "Map Type",
        mapVer: "Map Version",
        floor: "Floor",
        createdBy: "Created By",
      },
      columns: {
        mapId: "Map ID",
        siteId: "Site ID",
        mapName: "Map Name",
        mapTypeCd: "Map Type",
        mapImgBinr: "Map Image",
        mapImgUrl: "Map Image URL",
        imgSyncDt: "Image Sync DateTime",
        mapVer: "Map Version",
        floor: "Floor",
        orgGlbX: "Origin Global X",
        orgGlbY: "Origin Global Y",
        orgLat: "Origin Latitude",
        orgLon: "Origin Longitude",
        rsltMtrPerPixel: "Result Meter Per Pixel",
        rsltLatPerPixel: "Result Lat Per Pixel",
        rsltLonPerPixel: "Result Lon Per Pixel",
        rotatDegree: "Rotation Degree",
        mapWidthLenMtr: "Map Width (m)",
        mapHeightLenMtr: "Map Height (m)",
        displayOrd: "Display Order",
        createdBy: "Created By",
        createdAt: "Created Date",
        updatedBy: "Updated By",
        updatedAt: "Updated Date",
      },
      messages: {
        addSuccess: "Map has been added successfully.",
        addFailed: "Failed to add.",
        editSuccess: "Map information has been updated successfully.",
        editFailed: "Failed to update.",
        deleteSuccess: "Map has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        deleteConfirm: "Are you sure you want to delete this map?",
        exportSuccess: "Export completed successfully.",
        exportError: "Failed to export.",
        exportConfirm: "Do you want to export map data?",
      },
      editModal: {
        title: "Edit Map",
        mapIdPlaceholder: "Enter Map ID",
        siteIdPlaceholder: "Select Site ID",
        mapNamePlaceholder: "Enter Map Name",
        mapTypeCdPlaceholder: "Select Map Type",
        mapImgUrlPlaceholder: "Enter Map Image URL",
        mapImgBinrPlaceholder: "Select Map Image File",
        imgSyncDtPlaceholder: "Enter Image Sync DateTime",
        mapVerPlaceholder: "Enter Map Version",
        floorPlaceholder: "Enter Floor",
        orgGlbXPlaceholder: "Enter Origin Global X",
        orgGlbYPlaceholder: "Enter Origin Global Y",
        orgLatPlaceholder: "Enter Origin Latitude",
        orgLonPlaceholder: "Enter Origin Longitude",
        rsltMtrPerPixelPlaceholder: "Enter Result Meter Per Pixel",
        rsltLatPerPixelPlaceholder: "Enter Result Lat Per Pixel",
        rsltLonPerPixelPlaceholder: "Enter Result Lon Per Pixel",
        rotatDegreePlaceholder: "Enter Rotation Degree",
        mapWidthLenMtrPlaceholder: "Enter Map Width",
        mapHeightLenMtrPlaceholder: "Enter Map Height",
        displayOrdPlaceholder: "Enter Display Order",
      },
      addModal: {
        title: "Add Map",
      },
      image: {
        noImage: "No Image",
        clickToExpand: "Click to Expand",
        altText: "Map Image",
        defaultTitle: "Map Image",
        loadFailed: "Image Load Failed",
        loading: "Loading...",
        unsupportedType: "Unsupported Data Type",
      },
    },
  },
  report: {
    title: "Report",
    alarmLog: {
      title: "Alarm Log",
      search: "Search",
      columns: {
        datetime: "DateTime",
        robotName: "Robot Name",
        alarmCode: "Alarm Code",
        alarmMessage: "Alarm Message",
        status: "Status",
        priority: "Priority",
        equipmentName: "Equipment Name",
        robotGroupId: "Robot Group",
        description: "Description",
        position: "Position",
        occurTime: "Occur Time",
        releaseTime: "Release Time",
      },
      filters: {
        total: "Total",
      },
      messages: {
        exportConfirm: "Do you want to export the alarm log?",
        dateRangeLimit: "Please select a date range within 30 days for the report download.",
      },
    },
    serviceOrder: {
      title: "Service Order Report",
      search: "Search",
      orderType: "Order Type",
      reportType: {
        header: "Order Header",
        detail: "Order Detail",
      },
      columns: {
        orderId: "Order ID",
        serviceName: "Service Name",
        orderType: "Order Type",
        status: "Status",
        receiveDate: "Receive Date",
        startDate: "Start Date",
        endDate: "End Date",
        sequence: "Sequence",
        jobType: "Job Type",
        productCode: "Product Code",
        location: "Location",
      },
      messages: {
        exportConfirm: "Do you want to export the service order log?",
        dateRangeLimit: "The date range for download cannot exceed 30 days.",
      },
    },
    serviceDashboard: {
      title: "Service Dashboard",
      serviceOrder: "Service Order",
      todaysOrders: "Today's Orders",
      rate: "Rate",
      wait: "Wait",
      run: "Run",
      complete: "Complete",
      fail: "Fail",
      product: "Product",
      totalJobs: "Total Jobs",
      totalOrders: "Total Orders",
      status: "Status",
      total: "TOTAL",
      columns: {
        serviceName: "Service Name",
        orderId: "Order ID",
        startTime: "Start Time",
        endTime: "End Time",
      },
    },
    monthlyReport: {
      title: "Monthly Report",
      totalJob: "Total Job",
      successRate: "Success Rate",
      avgUtil: "Avg Util",
      totalRobots: "Total Robots",
      totalOperatingHours: "Total Operating Hours",
      totalTasks: "Total Tasks",
      avgEfficiency: "Average Efficiency",
      avgUtilization: "Average Utilization",
      dailyUsageChart: "Daily Usage Chart",
      robotTypeDistribution: "Job Distribution by Robot",
      robotSummary: "Robot Summary",
      serviceSummary: "Service Summary",
      robotDetails: "Robot Details",
      export: "Export",
      exporting: "Exporting...",
      filters: {
        all: "All",
      },
      label: {
        jobCount: "Job Count",
        totalJobCount: "Total Job Count",
        jobTime: "Job Time",
        totalJobTime: "Total Job Time",
        avgJobTime: "Avg Job Time",
        dayOfMonth: "Day of Month",
        jobs: "jobs",
      },
      columns: {
        totalJobCount: "Total Job Count",
        avgJobTime: "Avg Job Time",
        serviceName: "Service Name",
        srvcInstcNm: "Service Instance Name",
        successRate: "Success Rate",
        avgUtilization: "Avg Utilization",
        errorCount: "Error Count",
        robotGroup: "Robot Group",
        robotCount: "Robot Count",
        alarmCount: "Alarm Count",
        avgUptime: "Avg Uptime",
        lastActivity: "Last Activity",
        robotId: "Robot ID",
        robotName: "Robot Name",
        robotType: "Robot Type",
        operatingHours: "Operating Hours",
        tasksCompleted: "Tasks Completed",
        efficiency: "Efficiency",
        lastMaintenance: "Last Maintenance",
        status: "Status",
      },
      messages: {
        exportConfirm: "Do you want to export the monthly report?",
        exportSuccess: "Export completed successfully.",
        exportError: "Export failed. Please try again later.",
        fetchError: "Failed to fetch data. Please try again later.",
      },
    },
  },
  components: {
    searchFilter: {
      to: "~",
      defaultDescription: "A description of this list is provided here..",
    },
  },
  service: {
    button: {
      createService: "Create Service",
    },
    job: "Job",
    jobTitle: "Assign jobs by selecting items from Robot or Station Group.",
    robotCol: "Robot",
    stationCol: "Station",
    jobCol: "Job",
    selectTemplate: "Select template",
    selectInstance: "Select instance",
    title: "Select to place them in the Job area",
    title2: "Shift + Click to multi-select",
  },
  robotControl: {
    title: "Robot Control",
    breadcrumb: {
      current: "Robot Control",
    },
    robotSelection: {
      placeholder: "Select Robot",
    },
    controlButtons: {
      run: "RUN",
      stop: "STOP",
      chargeOn: "Charge On",
      chargeOff: "Charge Off",
      serviceStart: "Service Start",
      serviceStop: "Service Stop",
      resume: "Resume",
      pause: "Pause",
      docking: "Docking",
      volume: "Volume",
    },
    confirmMessages: {
      run: "Do you want to run the robot?",
      stop: "Do you want to stop the robot?",
      chargeOn: "Do you want to turn on charging?",
      chargeOff: "Do you want to turn off charging?",
      serviceStart: "Do you want to start the service?",
      serviceStop: "Do you want to stop the service?",
      resume: "Do you want to resume the robot?",
      pause: "Do you want to pause the robot?",
      docking: "Do you want to dock the robot?",
    },
    activity: {
      tabs: {
        todayJobs: "Today's Jobs",
        todayAlarms: "Today's Alarms",
      },
      search: {
        placeholder: "Enter your search term",
      },
      table: {
        columns: {
          time: "Time",
          serviceName: "Service Name",
          jobName: "Job Name",
          status: "Status",
          station: "Station",
        },
      },
    },
    utilizationChart: {
      title: "Utilization by Hour",
      chartLabel: "가동",
    },
    robotInfo: {
      position: "POSITION",
      connection: "Connection",
      destination: "DESTINATION",
      jobProgress: "Job progress",
      normal: "Normal",
    },
    robotControlRight: {
      loadingMaps: "Loading maps...",
      loadingMapImage: "Loading map image...",
      mapArea: "지도 영역",
      noMapsAvailable: "No maps available",
      failedToLoadMapImage: "Failed to load map image",
      mapId: "Map ID",
    },
    orderDelivery: {
      title: "Order and Delivery",
      todayOrders: "Today's Orders",
      date: "Date",
      hour: "시",
      pickup: "pickup",
      previous: "Previous",
      next: "Next",
    },
  },
  cafeOrder: {
    management: {
      title: "Cafe Order Management",
      badge: {
        paymentComplete: "Payment Completed",
        orderReceived: "Order Received",
        orderStarted: "Order Started",
        pickupWaiting: "Waiting for Pickup",
        orderCompleted: "Order Completed",
        orderCanceled: "Order Cancelled",
        orderPartialFail: "Order Partially Failed",
        partialOrderCancel: "Partial Order Cancelled",
        orderFail: "Order Failed",
        orderUnknown: "Unknown Order Status",
      },
    },
    fields: {
      orderId: "Order Id",
      householdName: "Household",
      orderStatus: "Order Status",
      rfCard: "RF Card",
      payCost: "Pay Cost",
      totalCost: "Total Cost",
      discountCost: "DC Cost",
      orderStartTime: "Order Start Time",
      orderCompleteTime: "Order Complete Time",
      odrCnclDt: "Order Cancel Time",
      odrCnclSrc: "Cancelled by",
      odrCnclSrcUser: "Order Cancel Source User",
      action: "Action",
      orderNo: "Order No",
    },
    actions: {
      detail: "Detail",
      cancel: "Cancel",
      close: "Close",
      cancelOrder: "Cancel Order",
      retry: "Retry",
      confirm: "Confirm",
      orderCancel: "Order Cancel",
    },
    modal: {
      orderDetail: "Order Detail",
    },
    status: {
      pending: "Pending",
    },
    messages: {
      failedToLoadDetails: "Failed to load order details",
      noSearchResults: "No search results found.",
      exportFailed: "Failed to export.",
      exportSuccess: "Export completed successfully.",
      noData: "No data available.",
      invalidCancellationQuantity: "Please select the quantity to cancel.",
    },
    auth: {
      title: "Enter the Password for two-factor authentication",
      enterPassword: "Enter your password",
      hidePassword: "Hide password",
      showPassword: "Show password",
      success: "Authentication successful",
      passwordRequired: "Password is required.",
    },
    detailCard: {
      detailNo: "Order Detail No.",
      menuName: "Menu Name",
      optionName: "Option Name",
      productQty: "Number of order",
      cnclQty: "Number of Cancel",
      unitPrice: "Unit Price",
      totalPrice: "Total Price",
    },
    orderCancel: {
      title: "Detail for the Order Cancel",
    },
  },
  household: {
    management: {
      title: "Household Management",
      actionsLabel: "Actions",
      breadcrumbs: {
        cafeManagement: "Cafe Management",
        householdManagement: "Household Management",
      },
      columns: {
        householdId: "ID",
        householdNm: "Name",
        householdInfo: "Info",
        householdNickname: "NickName",
        householdRfcardId: "RF Card",
        siteId: "Site ID",
        adpterId: "Adapter ID",
        useYn: "Usage Status",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
      messages: {
        deleteConfirm: "Are you sure you want to delete this household?",
        editConfirm: "Are you sure you want to edit the household?",
        noSearchResults: "No search results found.",
        createSuccess: "Household has been added successfully.",
        createFailed: "Failed to add.",
        editSuccess: "Household information has been updated successfully.",
        editFailed: "Failed to update.",
        deleteSuccess: "Household has been deleted successfully.",
        deleteFailed: "Failed to delete.",
        rfcardIdUpdated: "RFCard ID has been successfully updated.",
        updateFailed: "Failed to update RFCard ID.",
      },
      modalTitles: {
        add: "Add Household",
        edit: "Edit Household",
        passwordRequired: "Password Required",
        editRfcardId: "Edit RFCard ID",
      },
      validation: {
        noChangesDetected: "No changes detected.",
        rfcardIdRequired: "RFCard ID is required.",
      },
      placeholders: {
        householdId: "Enter Household ID",
        householdNm: "Enter Household Name",
        householdInfo: "Enter Household Info",
        householdNickname: "Enter Household Nickname",
        householdRfcardId: "Enter Household RFCard ID",
        useYn: "Select Use Y/N",
        enterPassword: "Enter Password",
        passwordPlaceholder: "Enter your password",
        rfcardIdPlaceholder: "Enter new RFCard ID",
      },
    },
  },
  cafeOrderStats: {
    management: {
      title: "Cafe Calendar",
      labels: {
        today: "Today",
        showDetailOrders: "Show Detail Orders",
        netAmount: "Net Amount",
        netOrders: "Net Orders",
        netBeverages: "Net Beverages Quantity",
        grossAmount: "Gross Amount",
        grossOrders: "Gross Orders",
        grossBeverages: "Gross Beverages Quantity",
        totalRevenue: "Total Revenue",
        totalAmount: "Total Amount",
        totalOrders: "Total Orders",
        totalBeverages: "Total Beverages Quantity",
        canceledAmount: "Canceled Amount",
        canceledOrders: "Canceled Orders",
        canceledBeverages: "Canceled Beverages Quantity",
        revenue: "Revenue",
        orders: "Orders",
        order: "Order",
        beverage: "Beverage",
        beverages: "Beverages",
        cancel: "Cancel",
        daily: "Daily",
        weekly: "Weekly",
        calendar: "Calendar",
        chart: "Chart",
        amount: "Amount",
        quantity: "Quantity",
        displayedDay: "Day in range: { displayedDays } / 7 days",
        displayedDays: "Days in range: { displayedDays } / 7 days",
      },
      units: {
        order: "order",
        orders: "orders",
        beverage: "beverage",
        beverages: "beverages",
      },
    },
    buttons: {
      retry: "Retry",
      detail: "Detail",
    },
    messages: {
      failedToLoadStatistics: "Failed to load statistics data",
      loadingStatistics: "Loading statistics...",
      noDataAvailable: "No Data Available",
      noDataForPeriod: "No order data available for {period}",
      cancelSuccess: "Order has been canceled successfully.",
    },
    errors: {
      invalidOrderId: "Invalid order ID",
      invalidStatisticsParams: "Invalid statistics parameters",
      loadError: "Unable to Load Data",
      loadFailed: "Failed to Load Statistics",
      noItemsSelected: "No items selected",
      passwordRequired: "Password is required",
      cancelFailed: "Failed to cancel.",
    },
  },
  executeService: {
    fields: {
      odrExecNm: "Execution Name",
      srvcInstcNm: "Service Name",
      execTypeCd: "Execution Type",
      strtDt: "Start Date Time",
      endDt: "Expire Time",
      robotName: "Robot Name",
      serviceTime: "Service Time",
      stnNameList: "Station Order",
      zoneNameList: "Zone Order",
      execCycleMn: "Period",
      lastExecDt: "Last Run Time",
      useYn: "Active",
      actions: "Actions",
    },
    composable: {
      noData: "No data",
      unnamedRoute: "unnamed Route",
    },
    options: {
      useYn: {
        all: "All",
        yes: "Active",
        no: "Inactive",
      },
    },
    messages: {
      createSuccess: "Service Execution has been added successfully.",
      createFailed: "Failed to add.",
      updateSuccess: "Service Execution has been updated successfully.",
      updateFailed: "Failed to update.",
      deleteConfirm: "Are you sure you want to delete this service execution?",
      deleteSuccess: "Service Execution has been deleted successfully.",
      deleteFailed: "Failed to delete.",
    },
    modal: {
      createTitle: "Add Service Execution",
      editTitle: "Edit Service Execution",
      step1: "Step 1",
      step2: "Step 2",
      selectZone: "Select Zone",
      selectedZones: "Selected Zones:",
      sections: {
        basic: "Basic Information",
        robot: "Robot Settings",
        location: "Location Settings",
        time: "Time Settings",
        advanced: "Advanced Settings",
        detail: "Detail Setting",
      },
      fields: {
        scheduleName: "Execution Name",
        scheduleNamePlaceholder: "Enter execution name",
        serviceGroup: "Service Group",
        serviceGroupPlaceholder: "Select service group",
        serviceInstance: "Service",
        serviceInstancePlaceholder: "Select service",
        robot: "Robot",
        robotPlaceholder: "Select robot",
        locationType: "Location Type",
        route: "Route",
        routePlaceholder: "Select route",
        zone: "Zone",
        zonePlaceholder: "Select zone",
        timeType: "Time Type",
        reserve: "Reserve",
        now: "Now",
        executeDate: "Start",
        executeTime: "Execute Time",
        period: "Period",
        periodPlaceholder: "Enter period",
        periodUnit: "Unit",
        minute: "Minute",
        minuteConfirm: "Minute(s)",
        hourConfirm: "Hour(s)",
        dayConfirm: "Day(s)",
        secondConfirm: "Second(s)",
        hour: "Hour",
        day: "Day",
        cycleEnabled: "Enable Cycle Count",
        cyclePeriod: "Cycle Count",
        cyclePeriodPlaceholder: "Enter cycle count",
        stayTimeEnabled: "Enable Stay Time",
        stayTime: "Stay Time (Seconds)",
        stayTimePlaceholder: "Enter stay time",
        expired: "Set Expiration",
        expireDate: "Expire Date",
        active: "Active",
        daySelectable: "Select Days",
        selectedDays: "Selected Days",
        actions: "Actions",
      },
      tabs: {
        once: "Execute Once",
        repeat: "Repeat Execution",
      },
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun",
      },
      buttons: {
        previous: "Previous",
        next: "Next",
        cancel: "Cancel",
        confirm: "Confirm",
        create: "Create",
        update: "Update",
        back: "Back",
        reset: "Reset",
      },
      validation: {
        scheduleNameRequired: "Please enter schedule name",
        serviceGroupRequired: "Please select service group",
        serviceInstanceRequired: "Please select service instance",
        robotRequired: "Please select robot",
        locationRequired:
          "The selected robot type does not match the location type. For PATROL robots, please select a Route. For CLEANING robots, please select a Zone.",
        routeRequired: "Please select route",
        zoneRequired: "Please select at least one zone",
        periodRequired: "Please enter period",
        periodInvalid: "Please enter valid period",
        cyclePeriodInvalid: "Please enter valid cycle count",
        stayTimeInvalid: "Please enter valid stay time",
        dayRequired: "Please select at least one day",
        expireDateInvalid: "Expire date must be after start date",
      },
      placeholders: {
        selectExecutionDate: "Select execution date",
        selectExpireDate: "Select expire date",
        selectServiceStartTime: "Start time",
        selectServiceEndTime: "End time",
      },
      labels: {
        now: "Now",
        period: "Period",
        minutes: "Minutes",
        seconds: "Seconds",
        secondConfirm: "Second(s)",
        second: "Second",
        hour: "Hour",
        days: "Days",
        expired: "Expired",
        setDay: "Set Day",
        cycle: "Cycle",
        times: "Times",
        time: "Time",
        stayTime: "Stay Time",
        active: "Active",
        serviceTime: "Service Time",
        serviceStartTime: "Service Start Time",
        serviceEndTime: "Service End Time",
      },
      confirmation: {
        title: "Confirm Service Execution",
        subtitle: "Do you want to create/update schedule with the following information?",
        sections: {
          basicInformation: "Basic Information",
          robotLocation: "Robot & Location",
          timeSettings: "Time Settings",
          additionalSettings: "Additional Settings",
          detail: "Detail Setting",
        },
        labels: {
          scheduleName: "Schedule Name",
          serviceGroup: "Service Group",
          serviceInstance: "Service Instance",
          scheduleType: "Schedule Type",
          robot: "Robot",
          locationType: "Location Type",
          location: "Location",
          timeType: "Time Type",
          executeDate: "Execute Date",
          period: "Period",
          serviceTime: "Service Time",
          serviceStartTime: "Service Start Time",
          serviceEndTime: "Service End Time",
          expireDate: "Expire Date",
          selectedDays: "Selected Days",
          cycle: "Cycle",
          stayTime: "Stay Time",
          active: "Active",
        },
        yes: "Yes",
        no: "No",
      },
    },
  },
  telephone: {
    management: {
      title: "Phone Number Mapping",
      actions: {
        addTelephone: "Add Telephone",
        editTelephone: "Edit Telephone",
        deleteTelephone: "Delete Telephone",
        deleteSelected: "Delete Selected",
        bulkDelete: "Bulk Delete",
        export: "Export",
        actions: "Actions",
      },
      actionsLabel: "Actions",
      columns: {
        cttTelNo: "Contact Telephone No",
        roleName: "Role Name",
        cttTelDesc: "Telephone Description",
        siteId: "Site ID",
        siteName: "Site Name",
        useYn: "Usage Status",
        createdAt: "Created At",
        updatedAt: "Updated At",
        startTime: "Start Time",
        endTime: "End Time",
        availableTime: "Receipt Time",
        cttPlanDay: "Receipt Day",
        setDay: "Set Receipt Day",
      },
      placeholders: {
        cttTelNo: "Enter Contact Telephone No",
        siteId: "Select Site",
        roleId: "Select Role",
        cttTelDesc: "Enter Contact Telephone Description",
        useYn: "Select Use Y/N",
      },
      labels: {
        setTime: "Set Receipt Time",
        always: "Always",
      },
      modalTitles: {
        add: "Add Phone Number",
        edit: "Edit Phone Number",
      },
      messages: {
        deleteConfirm: "Are you sure you want to delete this phone number?",
        deleteFailed: "Failed to delete.",
        createSuccess: "Phone Number has been added successfully.",
        createFailed: "Failed to add.",
        editSuccess: "Phone Number information has been updated successfully.",
        editFailed: "Failed to update.",
        confirmDeleteLinked: "The current phone number is in use. Are you sure you want to delete it?",
        deleteSuccess: "Phone Number has been deleted successfully.",
      },
    },
    validation: {
      selectAtLeastOne: "Select at least one day",
      startTimeEqualEndTime: "The start time and end time must not be the same.",
    },
    messages: {
      deleteConfirm: "Are you sure you want to delete this phone number?",
      noSearchResults: "No search results found.",
      createSuccess: "Phone Number has been added successfully.",
      createFailed: "Failed to add.",
      editSuccess: "Phone Number information has been updated successfully.",
      editFailed: "Failed to update.",
      deleteSuccess: "Phone Number has been deleted successfully.",
      deleteFailed: "Failed to delete.",
      invalidPhoneLength: "Phone number must be between {min} and {max} digits.",
    },
  },
  alarmRoleMapping: {
    title: "Alarm Role Mapping",
    label: {
      site: "Site",
      adapterName: "Adapter Name",
      role: "Role",
      phoneNumber: "Phone Number",
      selectAlarm: "Select Alarm",
      other: "other",
      others: "others",
      active: "Use",
      inactive: "Not Use",
    },
    columns: {
      adapterName: "Adapter Name",
      alarmName: "Alarm Name",
      alarmLevel: "Alarm Level",
      siteId: "Site ID",
      siteName: "Site Name",
      useYn: "Use Status",
      roleId: "Role ID",
      roleName: "Role Name",
      phoneNumber: "Phone Number",
      action: "Action",
    },
    filters: {
      adapterName: "Adapter Name",
      alarmName: "Alarm Name",
      alarmLevel: "Alarm Level",
      roleId: "Role ID",
      activeStatus: "Active Status",
    },
    levels: {
      info: "Info",
      warning: "Warning",
      error: "Error",
      critical: "Critical",
    },
    roles: {
      admin: "Admin",
      developer: "Developer",
    },
    status: {
      active: "Active",
      inactive: "Inactive",
    },
    modal: {
      createTitle: "Add Alarm Role",
      editTitle: "Edit Alarm Role",
    },
    adapterDetails: {
      title: "Adapter Alarm Details",
      tableTitle: "Alarm List",
      viewButton: "View Details",
      selectButton: "Select",
      moreButton: "More",
      quickView: "Selected Alarm Code",
      alarmCode: "Alarm Code",
      description: "Description",
      helperText: "Select an adapter and click the View Details button",
      selectedCount: "{count} selected",
      searchPlaceholder: "Search alarm name, code, or description...",
    },
    placeholders: {
      adapter: "Select Adapter",
      alarm: "Select Alarm",
      site: "Select Site",
      role: "Not Selected",
      phoneNumber: "Not Selected",
    },
    messages: {
      createSuccess: "Alarm Role has been added successfully.",
      createFailed: "Failed to add.",
      updateSuccess: "Alarm Role information has been updated successfully.",
      updateFailed: "Failed to update.",
      deleteSuccess: "Alarm Role has been deleted successfully.",
      deleteFailed: "Failed to delete.",
      deleteConfirm: "Are you sure you want to delete this alarm role?",
      fetchError: "Error fetching alarm role mappings.",
      roleOrPhoneRequired: "At least one contact (Role or Phone number) is required.",
      alarmCodeRequired: "Please select at least 1 Alarm Code.",
      siteRequired: "Please select a Site.",
      adapterRequired: "Please select an Adapter.",
      emptyPayload: "No data to submit. Please add at least one alarm code.",
      siteMaxLength: "Site ID exceeds maximum length of {max} characters.",
      adapterMaxLength: "Adapter ID exceeds maximum length of {max} characters.",
      alarmCodeMaxLength: "Alarm Code exceeds maximum length of {max} characters.",
      roleMaxLength: "Role ID exceeds maximum length of {max} characters.",
      phoneMaxLengthTotal: "Total phone numbers exceed maximum length of {max} characters when combined.",
      groupExistsConfirm:
        "Adapter: '{adapterName}' already has an alarm group for '{contact}', status '{useYn}'. Your selected alarms will be added to this group. Do you agree?",
      groupExistsConfirmNoContact:
        "Adapter: '{adapterName}' already has an alarm group with status '{useYn}'. Your selected alarms will be added to this group. Do you agree?",
    },
    validation: {
      adapterNameRequired: "Please enter adapter name.",
      alarmNameRequired: "Please enter alarm name.",
      alarmLevelRequired: "Please select alarm level.",
      siteIdRequired: "Please enter site ID.",
      roleIdRequired: "Please enter role ID.",
      phoneNumberRequired: "Please enter phone number.",
    },
  },
  timePicker: {
    labels: {
      hour: "Hour",
      minute: "Minute",
    },
  },
};
